import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function DriverTerms() {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto px-6 py-12 bg-gray-50">

      {/* BACK BUTTON */}
      <button
        onClick={() => navigate("/policies")}
        className="flex items-center gap-2 text-orange-500 font-medium mb-6"
      >
        <ArrowLeft size={18} />
        Back to Policies
      </button>

      {/* TITLE */}
      <h1 className="text-3xl font-bold mb-2">
        Jopo Delivery Driver App – Terms & Conditions
      </h1>

      <p className="text-gray-600 mb-6">
        Effective Date: 10/2/2026.
      </p>

    
      <p className="text-gray-700 mb-6">
        These Terms & Conditions (“Terms”) govern your access to and use of the Jopo Delivery Driver App (“the App”), operated by Jopo Delivery “We” By registering as a driver (“you”), you agree to be bound by these Terms.
      </p>

      <h2 className="text-xl font-bold mt-6">1. Role of Jopo Delivery & Driver Relationship.</h2>
      <p className="text-gray-700 mt-2">
        Jopo Delivery provides a digital platform that connects customers with independent delivery partners. Drivers are independent contractors and not employees, agents, or partners of Jopo Delivery. You control when and how you accept delivery requests, subject to platform rules and service standards.
      </p>

      <h2 className="text-xl font-bold mt-6">2. Eligibility & Onboarding.</h2>
      <p className="text-gray-700 mt-2">
        To use the Jopo Driver App, you must:
      </p>

      <ul className="list-disc ml-6 text-gray-700 mt-2">
        <li>Be at least 18 years old.</li>
        <li>Hold a valid National ID and, where applicable, a valid driving license, and a letter from government office.</li>
        <li>Provide accurate personal and vehicle information.</li>
        <li>Maintain a roadworthy vehicle and any required insurance.</li>
      </ul>

      <p className="text-gray-700 mt-2">
        Jopo Delivery reserves the right to approve, suspend, or reject driver applications at its discretion.
      </p>

      <h2 className="text-xl font-bold mt-6">3. Use of the App.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2">
        <li>The App allows you to receive delivery requests, navigate routes, confirm pickups and drop-offs, and view earnings.</li>
        <li>You agree to use the App only for lawful purposes and in accordance with these Terms.</li>
        <li>You are responsible for maintaining your device, internet access, and any costs related to your operations.</li>
      </ul>

      <h2 className="text-xl font-bold mt-6">4. Service Standards & Conduct.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2">
        <li>Handle parcels with care and deliver within reasonable timeframes.</li>
        <li>Communicate respectfully with customers and Jopo Delivery support.</li>
        <li>Follow traffic laws and safety guidelines.</li>
        <li>Not engage in fraudulent, abusive, or unsafe behaviour.</li>
      </ul>

      <p className="text-gray-700 mt-2">
        Failure to meet service standards may result in warnings, suspension, or termination of access to the platform.
      </p>

      <h2 className="text-xl font-bold mt-6">5. Prohibited Items.</h2>

      <p className="text-gray-700 mt-2">
        Drivers must not transport:
      </p>

      <ul className="list-disc ml-6 text-gray-700 mt-2">
        <li>Illegal or prohibited goods under Tanzanian law.</li>
        <li>Weapons, hazardous materials, or controlled substances.</li>
        <li>Any items that pose safety or legal risks.</li>
      </ul>

      <p className="text-gray-700 mt-2">
        Drivers have the right to refuse a delivery that they reasonably believe is unsafe or unlawful and should report such cases to Jopo.
      </p>

      <h2 className="text-xl font-bold mt-6">6. Fees, Earnings & Payments.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2">
        <li>Drivers earn fees per completed delivery, as displayed in the App.</li>
        <li>Jopo Delivery may charge a service or platform fee, which will be transparently communicated.</li>
        <li>Payouts are processed through approved mobile money or banking partners according to the payout schedule.</li>
        <li>Drivers are responsible for their own taxes, fuel, maintenance, and operating costs.</li>
      </ul>

      <h2 className="text-xl font-bold mt-6">7. Cancellations & Disputes.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2">
        <li>Cancellations may affect your performance metrics if done without valid reason.</li>
        <li>Any disputes regarding delivery completion, payments, or customer issues should be raised through the App or support channels within a reasonable time.</li>
        <li>Jopo Delivery will review disputes fairly and decide based on available information.</li>
      </ul>

      <h2 className="text-xl font-bold mt-6">8. Insurance & Liability.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2">
        <li>Drivers are responsible for maintaining valid vehicle insurance where required by law.</li>
        <li>Jopo Delivery does not provide vehicle insurance unless expressly stated.</li>
        <li>Jopo Delivery is not liable for personal injury, vehicle damage, or losses arising from your delivery activities, except where required by law.</li>
        <li>Optional parcel insurance may be offered for certain deliveries.</li>
      </ul>

      <h2 className="text-xl font-bold mt-6">9. Account Suspension & Termination.</h2>

      <p className="text-gray-700 mt-2">
        Jopo Delivery may suspend or terminate your access to the App if you:
      </p>

      <ul className="list-disc ml-6 text-gray-700 mt-2">
        <li>Breach these Terms.</li>
        <li>Provide false information.</li>
        <li>Engage in fraud, theft, harassment, or unsafe conduct.</li>
        <li>Repeatedly fail to meet service standards.</li>
      </ul>

      <p className="text-gray-700 mt-2">
        You may stop using the App at any time by deactivating your account.
      </p>

      <h2 className="text-xl font-bold mt-6">10. Data Protection & Privacy.</h2>
      <p className="text-gray-700 mt-2">
        Your personal data is processed in accordance with Jopo Delivery Driver Privacy & Data Protection Policy and the Tanzania Personal Data Protection Act, 2022. By using the App, you consent to such processing.
      </p>

      <h2 className="text-xl font-bold mt-6">11. Changes to These Terms.</h2>
      <p className="text-gray-700 mt-2">
        Jopo may update these Terms from time to time. Material changes will be communicated through the App or official channels. Continued use of the App after changes take effect constitutes acceptance of the updated Terms.
      </p>

      <h2 className="text-xl font-bold mt-6">12. Governing Law & Jurisdiction.</h2>
      <p className="text-gray-700 mt-2">
        These Terms are governed by the laws of the United Republic of Tanzania. Any disputes shall be subject to the jurisdiction of Tanzanian courts.
      </p>

      <h2 className="text-xl font-bold mt-6">13. Contact Information.</h2>
      <p className="text-gray-700 mt-2">
        Jopo Delivery Driver Support <br />
        Email: drivers@jopodelivery.com <br />
        Phone: +255689966875
      </p>

      {/* ORIGINAL CONTENT ENDS */}
    </div>
  );
}